import removeMarks from "./removeMarks";

export {
	removeMarks,
};
